import { CartLinesUpdateEvent } from '@shopify/events';

(function(){
  'use strict';
  if (window.__pbNativeInit) { return; }
  window.__pbNativeInit = true;

  var WISHLIST_KEY = 'petbabe_wishlist';

  function getWishlist(){
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch(e){ return []; }
  }
  function setWishlist(list){
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch(e){}
  }

  function showToast(message, imageUrl){
    var toast = document.getElementById('pb-toast');
    if(!toast) return;
    toast.querySelector('.pb-toast-message').textContent = message;
    var img = toast.querySelector('.pb-toast-image');
    if(imageUrl){ img.src = imageUrl; img.style.display = 'block'; } else { img.style.display = 'none'; }
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function(){ toast.classList.remove('is-visible'); }, 3200);
  }
  window.pbShowToast = showToast;

  function escapeHtml(str){
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }
  function stripHtml(html){
    var div = document.createElement('div');
    div.innerHTML = html || '';
    return div.textContent || div.innerText || '';
  }
  function formatMoney(cents){
    var n = parseInt(cents, 10);
    if(isNaN(n)) n = 0;
    return '$' + (n / 100).toFixed(2);
  }

  /**
   * Dispatches the official Shopify theme CartLinesUpdateEvent so the Horizon
   * theme's native cart-icon, cart-drawer, and cart-items-component all pick up
   * the change and re-render themselves (no page reload needed).
   * lines: array of { merchandiseId: <variantId>, quantity: <n> }
   */
  function dispatchCartLinesUpdate(lines){
    var cartPromise = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cartJson){
        return {
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cartJson),
          detail: { itemCount: cartJson.item_count, didError: false }
        };
      });
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      lines: lines,
      promise: cartPromise
    }));
  }

  function refreshWishlistUI(){
    var list = getWishlist();
    document.querySelectorAll('.pb-product-wishlist').forEach(function(btn){
      var handle = btn.getAttribute('data-product-handle');
      btn.classList.toggle('is-active', list.indexOf(handle) !== -1);
    });
    document.querySelectorAll('[data-pb-wishlist-count]').forEach(function(el){
      el.textContent = list.length;
      el.style.display = list.length > 0 ? '' : 'none';
    });
  }

  function initWishlistButtons(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.pb-product-wishlist');
      if(!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-handle');
      var list = getWishlist();
      var idx = list.indexOf(handle);
      if(idx === -1){ list.push(handle); showToast('Added to your wishlist ❤️'); }
      else { list.splice(idx,1); showToast('Removed from your wishlist'); }
      setWishlist(list);
      refreshWishlistUI();
    });
  }

  function initAddToCart(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.pb-product-add');
      if(!btn) return;
      if(btn.classList.contains('pb-product-choose')) return; /* handled by quick view opener instead */
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      var name = btn.getAttribute('data-product-name');
      var image = btn.getAttribute('data-product-image');
      var qty = 1;
      var qtyInput = document.querySelector('.pb-qv-qty-input');
      if(qtyInput){
        qty = parseInt(qtyInput.value, 10);
        if(isNaN(qty) || qty < 1) qty = 1;
      }
      if(!variantId){ showToast('This product has no purchasable variant right now.'); return; }
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      }).then(function(r){
        if(!r.ok) return r.json().then(function(d){ throw new Error(d.description || d.message || 'Could not add item'); });
        return r.json();
      }).then(function(){
        showToast('Added "' + name + '" to your cart!', image);
        dispatchCartLinesUpdate([{ merchandiseId: variantId, quantity: qty }]);
        if(document.getElementById('pb-modal-overlay') && document.getElementById('pb-modal-overlay').classList.contains('is-open')){
          closeModal();
        }
      }).catch(function(err){
        showToast(err.message || 'Could not add item to cart');
      }).finally(function(){
        btn.disabled = false;
      });
    });
  }

  function initQtyStepper(){
    document.addEventListener('click', function(e){
      var incBtn = e.target.closest('[data-qty-increase]');
      var decBtn = e.target.closest('[data-qty-decrease]');
      if(!incBtn && !decBtn) return;
      e.preventDefault();
      var wrapper = (incBtn || decBtn).closest('.pb-qv-qty-stepper');
      if(!wrapper) return;
      var input = wrapper.querySelector('.pb-qv-qty-input');
      if(!input) return;
      var val = parseInt(input.value, 10);
      if(isNaN(val) || val < 1) val = 1;
      if(incBtn) val += 1;
      if(decBtn) val = Math.max(1, val - 1);
      input.value = val;
    });
  }

  function initFilters(){
    document.querySelectorAll('[data-pb-filter-group]').forEach(function(group){
      var sel = group.getAttribute('data-pb-filter-group');
      if(!sel) return;
      var grid = document.querySelector(sel);
      if(!grid) return;
      group.addEventListener('click', function(e){
        var pill = e.target.closest('.pb-filter-pill');
        if(!pill || !group.contains(pill)) return;
        group.querySelectorAll('.pb-filter-pill').forEach(function(p){ p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var filterType = group.getAttribute('data-filter-type');
        var value = pill.getAttribute('data-filter-value');
        grid.setAttribute('data-active-' + filterType, value);
        applyFilters(grid);
      });
    });
  }

  function applyFilters(grid){
    var pet = grid.getAttribute('data-active-pet') || 'all';
    var cat = grid.getAttribute('data-active-category') || 'all';
    var visibleCount = 0;
    grid.querySelectorAll('.pb-product-card').forEach(function(card){
      var matchesPet = pet === 'all' || card.getAttribute('data-pet-type') === pet || card.getAttribute('data-pet-type') === 'both';
      var matchesCat = cat === 'all' || card.getAttribute('data-category') === cat;
      var show = matchesPet && matchesCat;
      card.style.display = show ? '' : 'none';
      if(show) visibleCount++;
    });
    var countEl = document.querySelector(grid.getAttribute('data-count-target'));
    if(countEl) countEl.textContent = visibleCount;
  }

  function initSort(){
    document.querySelectorAll('[data-pb-sort]').forEach(function(select){
      var sel = select.getAttribute('data-pb-sort');
      if(!sel) return;
      select.addEventListener('change', function(){
        var grid = document.querySelector(sel);
        if(!grid) return;
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.pb-product-card'));
        var mode = select.value;
        cards.sort(function(a,b){
          if(mode === 'price-asc') return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price'));
          if(mode === 'price-desc') return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price'));
          if(mode === 'bestseller') return (b.getAttribute('data-bestseller') === 'true' ? 1 : 0) - (a.getAttribute('data-bestseller') === 'true' ? 1 : 0);
          return 0;
        });
        cards.forEach(function(c){ grid.appendChild(c); });
      });
    });
  }

  /* ---- Shared modal (quick view + quiz) ---- */
  function ensureModal(){
    var overlay = document.getElementById('pb-modal-overlay');
    if(overlay) return overlay;
    overlay = document.createElement('div');
    overlay.id = 'pb-modal-overlay';
    overlay.className = 'pb-modal-overlay';
    overlay.innerHTML = '<div class="pb-modal" role="dialog" aria-modal="true"><button type="button" class="pb-modal-close" aria-label="Close">✕</button><div id="pb-modal-content"></div></div>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function(e){ if(e.target === overlay) closeModal(); });
    overlay.querySelector('.pb-modal-close').addEventListener('click', closeModal);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeModal(); });
    return overlay;
  }
  function openModal(html, narrow){
    var overlay = ensureModal();
    overlay.querySelector('#pb-modal-content').innerHTML = html;
    overlay.querySelector('.pb-modal').classList.toggle('pb-modal-narrow', !!narrow);
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    overlay.querySelector('.pb-modal').scrollTop = 0;
  }
  function closeModal(){
    var overlay = document.getElementById('pb-modal-overlay');
    if(!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.pbCloseModal = closeModal;

  /* ---- Quick view ---- */
  function initQuickView(){
    document.addEventListener('click', function(e){
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      if(e.target.closest('.pb-product-wishlist')) return;
      var card = e.target.closest('.pb-product-card[data-product-handle]');
      if(!card) return;
      e.preventDefault();
      openQuickView(card.getAttribute('data-product-handle'));
    });
  }

  function openQuickView(handle){
    openModal('<div style="padding:60px 20px;text-align:center;color:var(--pb-taupe);font-size:13px;">Loading…</div>');
    fetch('/products/' + handle + '.js')
      .then(function(r){ if(!r.ok) throw new Error('not found'); return r.json(); })
      .then(renderQuickView)
      .catch(function(){ openModal('<p style="padding:20px;text-align:center;font-size:13px;">Sorry, could not load this product.</p>'); });
  }

  function renderQuickView(p){
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var variants = p.variants || [];
    var available = variants.filter(function(v){ return v.available; });
    var firstAvailable = available[0] || variants[0] || {};
    var variantSelectHtml = '';
    if(variants.length > 1){
      variantSelectHtml = '<select class="pb-qv-variant-select">' +
        variants.map(function(v){
          return '<option value="' + v.id + '" data-price="' + v.price + '" data-image="' + (v.featured_image ? v.featured_image.src : img) + '"' + (v.id === firstAvailable.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + escapeHtml(v.title) + (v.available ? '' : ' (Out of stock)') + '</option>';
        }).join('') +
        '</select>';
    }
    var desc = stripHtml(p.description || '');
    if(desc.length > 200) desc = desc.slice(0, 200) + '…';
    var qtyStepperHtml = ''
      + '<div class="pb-qv-qty-row">'
      + '<span class="pb-qv-qty-label">Quantity</span>'
      + '<div class="pb-qv-qty-stepper">'
      + '<button type="button" class="pb-qv-qty-btn" data-qty-decrease aria-label="Decrease quantity">−</button>'
      + '<input type="number" class="pb-qv-qty-input" value="1" min="1" inputmode="numeric" aria-label="Quantity">'
      + '<button type="button" class="pb-qv-qty-btn" data-qty-increase aria-label="Increase quantity">+</button>'
      + '</div>'
      + '</div>';
    var html = ''
      + '<div class="pb-qv-grid">'
      + '<div class="pb-qv-image"><img src="' + img + '" alt="' + escapeHtml(p.title) + '"></div>'
      + '<div class="pb-qv-info">'
      + '<h3 class="pb-heading pb-qv-title">' + escapeHtml(p.title) + '</h3>'
      + '<div class="pb-qv-price" id="pb-qv-price">' + formatMoney(firstAvailable.price) + '</div>'
      + (desc ? '<p class="pb-qv-desc">' + escapeHtml(desc) + '</p>' : '')
      + variantSelectHtml
      + qtyStepperHtml
      + '<div class="pb-qv-actions">'
      + '<button type="button" class="pb-btn pb-btn-primary pb-product-add" data-variant-id="' + (firstAvailable.id || '') + '" data-product-name="' + escapeHtml(p.title) + '" data-product-image="' + img + '">🛍️ Add to Cart</button>'
      + '<a href="' + p.url + '" class="pb-btn pb-btn-secondary">View Full Details →</a>'
      + '</div>'
      + '</div>'
      + '</div>';
    openModal(html, false);
    var select = document.querySelector('.pb-qv-variant-select');
    if(select){
      select.addEventListener('change', function(){
        var opt = select.options[select.selectedIndex];
        var priceEl = document.getElementById('pb-qv-price');
        if(priceEl) priceEl.textContent = formatMoney(opt.getAttribute('data-price'));
        var addBtn = document.querySelector('.pb-qv-actions .pb-product-add');
        if(addBtn) addBtn.setAttribute('data-variant-id', opt.value);
        var newImg = opt.getAttribute('data-image');
        var imgEl = document.querySelector('.pb-qv-image img');
        if(newImg && imgEl) imgEl.src = newImg;
      });
    }
  }

  /* ---- Style quiz ---- */
  var quizState = { step: 1, petType: null, size: null, priority: null };
  var QUIZ_SIZE_OPTIONS = [
    { id: 'petite', label: 'Petite (< 11 lbs / 5 kg)', desc: 'Kittens, Poodles, Chihuahuas, Frenchies...' },
    { id: 'medium', label: 'Medium (11 – 33 lbs / 5 – 15 kg)', desc: 'Chubby Cats, Corgis, Shibas, Pugs...' },
    { id: 'large', label: 'Large (> 33 lbs / 15 kg)', desc: 'Goldens, Labradors, Huskies, Shepherds...' }
  ];
  var QUIZ_PRIORITY_OPTIONS = [
    { id: 'sleep', icon: '🛌', label: 'Deep Sleep & Rest', desc: 'Orthopedic anti-anxiety bedding' },
    { id: 'energy', icon: '🎾', label: 'Fun & Energy Release', desc: 'Interactive toys and scratchers' },
    { id: 'dining', icon: '🍽️', label: 'Healthy Dining', desc: 'Ceramic bowls & water fountains' },
    { id: 'outings', icon: '🎒', label: 'Stylish Outings', desc: 'Backpacks & genuine leather harnesses' }
  ];

  function getQuizRules(){
    var el = document.getElementById('pb-quiz-rules');
    if(!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch(e){ return []; }
  }
  function getQuizProducts(){
    var el = document.getElementById('pb-quiz-products');
    if(!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch(e){ return {}; }
  }
  function getQuizConfig(){
    var defaults = { eyebrow: 'PetBabe Style Match Assistant', heading: 'Find Perfect Gear For Your Pet', stepLabel: 'Answer 3 quick questions' };
    var el = document.getElementById('pb-quiz-config');
    if(!el) return defaults;
    try {
      var parsed = JSON.parse(el.textContent) || {};
      for(var k in defaults){ if(!parsed[k]) parsed[k] = defaults[k]; }
      return parsed;
    } catch(e){ return defaults; }
  }

  function openQuiz(){
    quizState = { step: 1, petType: null, size: null, priority: null };
    renderQuizStep();
  }
  window.pbOpenQuiz = openQuiz;

  function quizShell(bodyHtml, stepNum){
    var cfg = getQuizConfig();
    var stepText = stepNum <= 3 ? ('Step ' + stepNum + '/3: ' + cfg.stepLabel) : 'Tailored recommendation bundle for your pet';
    return '<div class="pb-quiz">'
      + '<div style="text-align:center;">'
      + '<span class="pb-eyebrow">✨ ' + escapeHtml(cfg.eyebrow) + '</span>'
      + '<h3 class="pb-heading" style="font-size:22px;margin:14px 0 4px;">' + escapeHtml(cfg.heading) + '</h3>'
      + '<p style="font-size:12px;color:var(--pb-taupe);margin-bottom:20px;">' + escapeHtml(stepText) + '</p>'
      + '</div>'
      + bodyHtml
      + '</div>';
  }

  function renderQuizStep(){
    var html;
    if(quizState.step === 1){
      var petOpts = [ { id: 'dog', icon: '🐶', label: 'Dog / Puppy' }, { id: 'cat', icon: '🐱', label: 'Cat / Kitten' } ];
      html = '<p class="pb-quiz-question">1. What kind of pet do you have?</p>'
        + '<div class="pb-quiz-grid-2">'
        + petOpts.map(function(o){
            return '<button type="button" class="pb-quiz-option pb-quiz-option-icon" data-quiz-pet="' + o.id + '">'
              + '<span class="pb-quiz-option-emoji">' + o.icon + '</span>'
              + '<span class="pb-quiz-option-label">' + o.label + '</span>'
              + '</button>';
          }).join('')
        + '</div>';
      openModal(quizShell(html, 1), true);
    } else if(quizState.step === 2){
      html = '<p class="pb-quiz-question">2. What is your pet\'s size or weight?</p>'
        + '<div class="pb-quiz-list">'
        + QUIZ_SIZE_OPTIONS.map(function(o){
            return '<button type="button" class="pb-quiz-option pb-quiz-option-row" data-quiz-size="' + o.id + '">'
              + '<span class="pb-quiz-option-title">' + escapeHtml(o.label) + '</span>'
              + '<span class="pb-quiz-option-desc">' + escapeHtml(o.desc) + '</span>'
              + '</button>';
          }).join('')
        + '</div>';
      openModal(quizShell(html, 2), true);
    } else if(quizState.step === 3){
      html = '<p class="pb-quiz-question">3. What is your top priority right now?</p>'
        + '<div class="pb-quiz-grid-2">'
        + QUIZ_PRIORITY_OPTIONS.map(function(o){
            return '<button type="button" class="pb-quiz-option pb-quiz-option-icon" data-quiz-priority="' + o.id + '">'
              + '<span class="pb-quiz-option-emoji">' + o.icon + '</span>'
              + '<span class="pb-quiz-option-title">' + escapeHtml(o.label) + '</span>'
              + '<span class="pb-quiz-option-desc">' + escapeHtml(o.desc) + '</span>'
              + '</button>';
          }).join('')
        + '</div>';
      openModal(quizShell(html, 3), true);
    } else {
      renderQuizResults();
    }
  }

  function renderQuizResults(){
    var rules = getQuizRules();
    var productMap = getQuizProducts();
    var rule = rules.filter(function(r){ return r.petType === quizState.petType && r.priority === quizState.priority; })[0];
    if(!rule){ rule = rules.filter(function(r){ return r.petType === quizState.petType; })[0]; }
    var sizeLabelMap = { petite: 'small', medium: 'medium', large: 'large' };
    var petLabel = quizState.petType === 'dog' ? 'Dog' : 'Cat';
    var sizeLabel = sizeLabelMap[quizState.size] || quizState.size || '';
    var bundleLabel = (rule && rule.bundleLabel) || ('Curated bundle for your ' + petLabel + (sizeLabel ? ' (' + sizeLabel + ')' : '') + ':');
    var handles = (rule && rule.productHandles) || [];
    var products = handles.map(function(h){ return productMap[h]; }).filter(Boolean);
    var itemsHtml = products.map(function(p){
      return '<div class="pb-quiz-result-item">'
        + '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '">'
        + '<div class="pb-quiz-result-info">'
        + '<h5>' + escapeHtml(p.title) + '</h5>'
        + (p.subtitle ? '<p>' + escapeHtml(p.subtitle) + '</p>' : '')
        + '<div class="pb-quiz-result-price">' + formatMoney(p.price) + '</div>'
        + '</div></div>';
    }).join('');
    var variantIds = products.map(function(p){ return p.variantId; }).filter(Boolean);
    var html = '<div class="pb-quiz-result-banner">✨ ' + escapeHtml(bundleLabel) + '</div>'
      + '<div class="pb-quiz-result-list">' + (itemsHtml || '<p style="font-size:12px;color:var(--pb-taupe);text-align:center;">No recommendations set up yet for this combination — add products to this quiz rule in the Theme Customizer.</p>') + '</div>'
      + '<div class="pb-quiz-result-actions">'
      + '<button type="button" class="pb-btn pb-btn-primary pb-quiz-add-bundle" data-variant-ids="' + variantIds.join(',') + '">🛍️ Add Recommended Bundle To Cart</button>'
      + '<button type="button" class="pb-quiz-retake">↺ Retake Quiz</button>'
      + '</div>';
    openModal(quizShell(html, 4), true);
  }

  function initQuiz(){
    document.addEventListener('click', function(e){
      var trigger = e.target.closest('[data-open-quiz]');
      if(trigger){ e.preventDefault(); openQuiz(); return; }

      var petBtn = e.target.closest('[data-quiz-pet]');
      if(petBtn){ quizState.petType = petBtn.getAttribute('data-quiz-pet'); quizState.step = 2; renderQuizStep(); return; }

      var sizeBtn = e.target.closest('[data-quiz-size]');
      if(sizeBtn){ quizState.size = sizeBtn.getAttribute('data-quiz-size'); quizState.step = 3; renderQuizStep(); return; }

      var prioBtn = e.target.closest('[data-quiz-priority]');
      if(prioBtn){ quizState.priority = prioBtn.getAttribute('data-quiz-priority'); quizState.step = 4; renderQuizStep(); return; }

      var retakeBtn = e.target.closest('.pb-quiz-retake');
      if(retakeBtn){ openQuiz(); return; }

      var addBundleBtn = e.target.closest('.pb-quiz-add-bundle');
      if(addBundleBtn){
        e.preventDefault();
        var ids = (addBundleBtn.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
        if(!ids.length){ showToast('No products configured for this bundle yet.'); return; }
        addBundleBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ids.map(function(id){ return { id: id, quantity: 1 }; }) })
        }).then(function(r){
          if(!r.ok) return r.json().then(function(d){ throw new Error(d.description || d.message || 'Could not add bundle'); });
          return r.json();
        }).then(function(){
          showToast('Bundle added to your cart! 🎉');
          dispatchCartLinesUpdate(ids.map(function(id){ return { merchandiseId: id, quantity: 1 }; }));
          closeModal();
        }).catch(function(err){
          showToast(err.message || 'Could not add bundle');
        }).finally(function(){
          addBundleBtn.disabled = false;
        });
      }
    });
  }

  function pbReady(fn){
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function safe(fn, label){
    try { fn(); } catch(e){ if(window.console) console.error('[petbabe-native] ' + label + ' failed:', e); }
  }

  pbReady(function(){
    safe(initWishlistButtons, 'initWishlistButtons');
    safe(initAddToCart, 'initAddToCart');
    safe(initQtyStepper, 'initQtyStepper');
    safe(initFilters, 'initFilters');
    safe(initSort, 'initSort');
    safe(initQuickView, 'initQuickView');
    safe(initQuiz, 'initQuiz');
    safe(refreshWishlistUI, 'refreshWishlistUI');
  });
})();
